import { defineComponent as _defineComponent } from 'vue'

const __default__ = {
  name: 'TInput',
  model: {
    prop: 'modelValue',
    event: 'input',
  },
};

import { computed } from '@nuxtjs/composition-api';

export type Input = string | boolean | number | null;

export interface InputProps {
  modelValue?: Input;
}

export type InputEmits = (event: 'input', value: Input) => void;


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    modelValue: { type: [String, Boolean, Number, null] }
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ((event: 'input', value: Input) => void), expose: any, slots: any, attrs: any }) {

const props = __props as {
  modelValue?: Input;
};




const proxyModelValue = computed({
  get() {
    return props.modelValue;
  },
  set(val?: Input) {
    if (val) {
      emit('input', val);
    }
  },
});

return { __sfc: true,props, emit, proxyModelValue }
}

})